<div class="modal-header">
  <h4 class="modal-title">Export Template</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <button
        class="btn btn-default float-right"
        type="button"
        (click)="addTemplate()"
      >
        <i class="fas fa-plus"></i> Add New Export Template
      </button>
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Template Name</th>
            <th>Export As</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let template of templates.data; let i = index">
            <td (click)="gotoViewTemplate(template)" class="link">
              <span class="text-info">{{ template.name }}</span>
            </td>
            <td>
              <a
                class="btn btn-default"
                href="javascript:void(0);"
                (click)="exportTemplate(template, 'pdf')"
              >
                <i class="fas fa-file-pdf"></i> PDF
              </a>
              <a
                class="btn btn-default"
                href="javascript:void(0);"
                (click)="exportTemplate(template, 'csv')"
              >
                <i class="fas fa-file-csv"></i> CSV
              </a>
              <a
                class="btn btn-default"
                href="javascript:void(0);"
                (click)="exportTemplate(template, 'xlsx')"
              >
                <i class="fas fa-file-excel"></i> XLSX
              </a>
            </td>
            <td class="text-right">
              <div ngbDropdown class="d-inline-block" append-to="body">
                <button
                  ngbDropdownToggle
                  mat-mini-fab
                  type="button"
                  color="default"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="flaticon-more-1"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="action-button">
                  <button ngbDropdownItem (click)="editTemplate(template)">
                    <i class="fas fa-edit text-info"></i> Edit
                  </button>
                  <button
                    type="button"
                    ngbDropdownItem
                    (click)="deleteTemplate(template)"
                  >
                    <i class="fas fa-trash text-danger"></i> Delete
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <mat-paginator
        [length]="templates.meta?.total"
        [pageSize]="templates.meta?.per_page"
        [pageSizeOptions]="pageSizeOptions"
        (page)="getRecords($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-danger"
    (click)="activeModal.dismiss('')"
    [translate]="'BUTTONS.CLOSE'"
  >
    <i class="fas fa-times"></i> Close
  </button>
</div>
